<div class="organisation-services-tab" data-testid="organisation-services-tab">
    @if (!isActive) {
        <div class="alert alert-info" role="status" data-testid="organisation-services-inactive">
            This organisation is {{ organisation?.deletedAt ? 'deleted' : 'deactivated' }}. Linked services cannot be viewed or changed.
        </div>
    } @else if (loading) {
        <spinner></spinner>
    } @else {
        @if (loadError) {
            <div class="alert alert-warning" role="alert" data-testid="organisation-services-error">{{ loadError }}</div>
        } @else if (rows.length === 0) {
            <p class="text-muted" data-testid="organisation-services-empty">No services linked</p>
        } @else {
            <div class="table-responsive">
                <table class="table table-sm align-middle" data-testid="organisation-services-table">
                    <caption class="visually-hidden">Services linked to this organisation</caption>
                    <thead>
                        <tr>
                            <th scope="col">Name</th>
                            <th scope="col">Address</th>
                            <th scope="col">City</th>
                            <th scope="col">Postcode</th>
                            <th scope="col">Added on</th>
                            @if (canWrite) {
                                <th scope="col">Actions</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        @for (row of rows; track row.id) {
                            <tr data-testid="organisation-service-row">
                                <td>
                                    {{ row.name }}
                                    @if (row.disabledAt) {
                                        <span class="badge badge-deactivated ms-2" data-testid="organisation-service-deactivated">Deactivated</span>
                                    }
                                </td>
                                <td>{{ row.address }}</td>
                                <td>{{ row.city }}</td>
                                <td>{{ row.postcode }}</td>
                                <td>{{ row.addedOn | date: 'dd/MM/yyyy' }}</td>
                                @if (canWrite) {
                                    <td>
                                        <button type="button" class="btn btn-link link-danger p-0 align-baseline"
                                                [attr.aria-label]="'Unlink service ' + row.name"
                                                [disabled]="removing"
                                                confirmHeader="Confirm the action"
                                                confirmModal="Are you sure you want to unlink the selected service from this organisation?"
                                                [confirmMessage]="row.name"
                                                confirmOk="Yes, proceed"
                                                confirmCancel="No, cancel"
                                                confirmOkClass="btn-outline-danger"
                                                confirmCancelClass="btn-gray text-dark"
                                                [confirmCancelFirst]="true"
                                                (confirmedClick)="unlink(row)"
                                                data-testid="organisation-service-unlink">
                                            <i class="bi bi-x-lg" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
        @if (canWrite) {
            <div class="organisation-services-actions">
                <button type="button" class="btn btn-success" #linkButton
                        [disabled]="removing"
                        (click)="openLinkModal()"
                        data-testid="organisation-services-link">
                    <i class="bi bi-link-45deg me-2" aria-hidden="true"></i>Link services
                </button>
            </div>
        }
    }
</div>
